import { configureStore, combineReducers } from '@reduxjs/toolkit';
import redditReducer from './redditSlice';
import subRedditReducer from './subRedditSlice';


export default configureStore({
   reducer: combineReducers({
      reddit: redditReducer,
      subreddits: subRedditReducer,
   }),
});
